import React from 'react';

import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *, *:before, *:after {
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;

  }

  * {
    /* margin: 0;*/
  }
  /*
    Add accessible line-height
    Improve text rendering
  */
  body {
    line-height: calc(1em + 0.725rem);
    -webkit-font-smoothing: antialiased;
  }
  /*
    Improve media defaults
  */
  img, picture, video, canvas, svg {
    display: block;
    max-width: 100%;
  }
  /*
    Remove built-in form typography styles
  */
  input, button, textarea, select {
    font: inherit;
  }
  /*
    Avoid text overflows
  */
  p, h1, h2, h3, h4, h5, h6 {
    overflow-wrap: break-word;
  }
  /*
    Create a root stacking context
  */
  #root, #__next {
    isolation: isolate;
  }

  body {
    background: var(--color-background);
    color: var(--color-text);
  }

  a {
    color: var(--color-secondary);
  }

  a::visited {
    color: var(--color-visited);
  }
`;

export default GlobalStyles;